import { filterBlank } from '@dte/otw-utils-core/src/lists/filterEmpty';
import { isEmptyArray } from '@dte/otw-utils-core/src/objects/isEmpty';

export function joinUrlPaths(paths: Array<string | undefined>): string | undefined {
	let filteredPaths = filterBlank(paths);
	filteredPaths = filteredPaths.map((path) => path?.replace(/^\/|\/$/g, ''));

	if (isEmptyArray(filteredPaths)) {
		return undefined;
	}

	return filteredPaths.join('/');
}
